export const DECLAREPROPOSALLIST_SEARCH = 'DECLAREPROPOSALLIST_SEARCH';
export const DECLAREPROPOSALLIST_PAGE = 'DECLAREPROPOSALLIST_PAGE';
export const DECLAREPROPOSALLIST_MANAGER = 'DECLAREPROPOSALLIST_MANAGER';
